import { invoiceKeyFromInvoice } from './MerchandiseUIReducer';

export function getMerchandiseInvoiceKey(getState, invoiceItemIndex) {
  const invoice =
    getState()?.DescriptionOfMerchandise?.entrySummaryInvoices?.[invoiceItemIndex];
  return invoiceKeyFromInvoice(invoice, invoiceItemIndex);
}
